var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.655 12.3962L7.65332 8.39453",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3938 4.65234L15.3955 8.65401",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99634 21.0041H13.5867",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89673 21.0052L4.44196 19.3725C4.71363 18.5568 5.47601 18.0059 6.33574 18.0039H10.2474C11.1097 18.0028 11.8757 18.5544 12.1482 19.3725L12.6894 21.0052",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89082 7.30045L6.68991 9.05618C6.28296 9.38164 6.03351 9.86471 6.00373 10.3849C5.97396 10.9052 6.16668 11.4136 6.53384 11.7833L8.21054 13.468C8.57468 13.8341 9.07749 14.0277 9.59308 14.0004C10.1087 13.973 10.5882 13.7274 10.9117 13.325L12.6884 11.118C13.1088 10.5954 13.5852 10.1203 14.109 9.70145L16.3099 7.94572C16.7169 7.62025 16.9663 7.13718 16.9961 6.61695C17.0259 6.09672 16.8331 5.58834 16.466 5.21858L14.7923 3.53488C14.4281 3.16884 13.9253 2.97524 13.4097 3.00254C12.8941 3.02985 12.4146 3.27548 12.0912 3.67794L10.3124 5.88486C9.89194 6.40746 9.4152 6.88219 8.89082 7.30045Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3771 9.48828L20.3036 14.5034C20.8676 14.9826 21.1184 15.7356 20.9546 16.4573C20.7908 17.179 20.2393 17.7499 19.5237 17.9386C18.8081 18.1273 18.0469 17.9026 17.5484 17.3556L12.3123 11.5892",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderIcon);
export default __webpack_public_path__ + "static/media/tender-icon.02a1546f59abbb5a53b452f404881d81.svg";
export { ForwardRef as ReactComponent };